export abstract class ErrorMessageResource {
  maxlength?: string;
  minlength?: string;
  pattern?: string;
  required?: string;
}
